import { useTranslation as e } from "../../i18n.mjs";
import { ToolbarSelect as t } from "../../components/content-controls/toolbar-select.mjs";
import { ToolbarSheetSelect as n } from "../../components/content-controls/toolbar-sheet-select.mjs";
import { isImageSelected as r } from "../image-extension/utils/is-image-selected.mjs";
import { getFontSizeValues as i } from "./utils/font-size.mjs";
import { useEditorState as a } from "@tiptap/react";
import { useMemo as o } from "react";
import { jsx as s } from "react/jsx-runtime";
import { FontSizeIcon as c } from "@systemeio/icons";
//#region src/extensions/font-size-extension/use-font-size-extension-toolbar.tsx
var l = (l, u) => {
	let { t: d } = e(), f = a({
		editor: l,
		selector: ({ editor: e }) => ({
			isEditable: e?.options.editable ?? !1,
			fontSize: e?.getAttributes("textStyle").fontSize || null,
			isImageSelected: r(e)
		})
	}), p = !f?.isEditable || !!f?.isImageSelected, m = f?.fontSize ?? null;
	return o(() => {
		let e = (e) => {
			if (!l) return null;
			e ? l.chain().focus().setFontSize(e).run() : l.chain().focus().unsetFontSize().run();
		};
		return {
			toolbarRender: /* @__PURE__ */ s(t, {
				clearLabel: d("global.clear"),
				disabled: p,
				label: d("font_size"),
				labelledByContent: !!m,
				onChange: e,
				onClear: u?.clearable ? () => e(null) : void 0,
				options: i(),
				value: m,
				children: m ?? /* @__PURE__ */ s(c, {})
			}),
			sheetRender: /* @__PURE__ */ s(n, {
				disabled: p,
				icon: /* @__PURE__ */ s(c, {}),
				label: d("font_size"),
				onChange: e,
				options: i(),
				value: m
			})
		};
	}, [
		l,
		p,
		u?.clearable,
		m,
		d
	]);
};
//#endregion
export { l as useFontSizeExtensionToolbar };
